import { UserRole } from '../types/user';
import { getCurrentUser } from '../services/userService';

/**
 * Permission utility functions for role-based access control
 * 
 * As per design document:
 * - FACILITY_USER: Can create, edit, and update projects
 * - SUBCOUNTY_USER: Can only view and comment (read-only)
 * - COUNTY_USER: Can only view and comment (read-only)
 * - NATIONAL_USER: Can only view and comment (read-only)
 * - CQI_MANAGER: Full access (admin)
 */

/**
 * Check if user can update project progress
 * Only FACILITY_USER and CQI_MANAGER can update progress
 */
export const canUpdateProgress = (): boolean => {
  const user = getCurrentUser();
  if (!user) return false;
  
  return user.role === UserRole.FACILITY_USER;
};

/**
 * Check if user can only comment (read-only access)
 * SUBCOUNTY_USER, COUNTY_USER, and NATIONAL_USER can only comment
 */
export const canOnlyComment = (): boolean => {
  const user = getCurrentUser();
  if (!user) return false;
  
  return user.role === UserRole.SUBCOUNTY_USER || 
         user.role === UserRole.COUNTY_USER || 
         user.role === UserRole.NATIONAL_USER;
};
